import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.less']
})
export class GroupsComponent implements OnInit {
  isCollapsed = false;
  groups:any=[];
  perPage = 10;
  page = 1;
  total:number;
  getFullYear: number = new Date().getFullYear();
  loading:boolean;
  constructor(
    private userService:UserService,
  ) { }

  ngOnInit() {
    this.department();
  }

  department(perPage = this.perPage, page = this.page){
    this.loading = true;
    this.userService.getDepartment(perPage,page).subscribe((res:any)=>{    
      this.groups = res.data.data;
      this.total = res.data.total;
      this.loading = false;
    });
  }

  onPageIndexChange($event) {
    this.department(this.perPage, $event);
    window.scroll(0,0);
  }

}
